import { TransmissionTowerExportIcon } from './TransmissionTowerExportIcon';

/**
 * author: Michael Irigoyen
 * id F1AC7C0E-CA03-4ED0-AFE9-CE0CEB3C9806
 * name transmission-tower-export
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transmission-tower-export.svg
 * tags
 * - Home Automation 
 */
export const PowerFromGridIcon = TransmissionTowerExportIcon;
export default PowerFromGridIcon